export default "__VITE_ASSET__ca795853__"